export const prosBrowseZoneCExperimentRowIndex = {
  '670-22': 8,
};

export const prosBrowseExperimentRowIndex = {
  '820-21': 2,
  '823-21': 2,
  '824-21': 2,
  '829-21': 2,
  '830-21': 2,
  '1213-21': 2,
  '1214-21': 2,
  '1215-21': 2,
  '1216-21': 2,
  '1217-21': 2,
};
